<template>
  <div>
    <!-- Modal Tambah Akun Whitelisted -->
    <BModal
      id="modal-add-account"
      hide-footer
      hide-header
      :centered="true"
      content-class="rounded-lg"
      @shown="onShown"
    >
      <h1 class="text-[#333333] font-semibold text-[18px] text-center my-1">
        Tambah Akun Whitelisted Partner
      </h1>
      <div
        v-if="platform === 'meta'"
        class="flex w-full font-medium text-[16px] mb-[.5rem]"
      >
        <button
          v-for="type in adAccountTypes"
          :key="type"
          class="w-full border-b-[1px] focus:outline-none py-[.75rem] rounded-t-md"
          :class="{'text-primary border-[#F95031] !border-b-[2px] bg-[#FFF4F2]': form.ad_account_type === type.key}"
          @click="() => onSelectAdType(type.key)"
        >
          {{ type.text }}
        </button>
      </div>
      <ValidationObserver #default="{ invalid }">
        <div class="p-1">
          <BForm>
            <div class="mb-2">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="Nama akun WL"
              >
                <label
                  class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                >
                  Masukkan nama akun WL <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.account_name"
                  placeholder="Masukkan nama akun"
                  class="w-full"
                  :class="{ 'is-invalid': errors.length > 0 || validationError.account_name }"
                  required
                />
                <span
                  v-if="errors.length > 0 || validationError.account_name"
                  class="text-danger text-sm"
                >{{ errors[0] || validationError.account_name }}</span>
              </ValidationProvider>
            </div>

            <div
              v-if="platform === 'meta'"
              class="mb-2"
            >
              <div v-if="form.ad_account_type === adAccountTypes[1].key">
                <!-- Marketplace -->
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Marketplace"
                  rules="required"
                >
                  <div class="mb-[16px] text-left">
                    <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                      Pilih Marketplace
                      <span class="text-primary">*</span>
                    </label>
                    <BFormSelect
                      v-model="form.marketplace"
                      :options="marketplaceOptions"
                    />
                    <span
                      v-if="errors.length > 0"
                      class="text-danger text-sm"
                    >{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
                <!-- Marketplace Sync Email -->
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  name="Email yang tertaut ke marketplace"
                >
                  <div class="mb-[16px] text-left">
                    <label
                      class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                    >
                      Email yang tertaut ke marketplace <span class="text-primary">*</span>
                    </label>
                    <BFormInput
                      v-model="form.marketplace_sync_email"
                      placeholder="Masukkan email disini"
                      class="w-full"
                      required
                    />
                    <span
                      v-if="errors.length > 0"
                      class="text-danger text-sm"
                    >{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
              <!-- BM ID -->
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="ID BM"
              >
                <div class="mb-[16px] text-left">
                  <label
                    class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                  >
                    Masukkan ID BM <span class="text-primary">*</span>
                  </label>
                  <BFormInput
                    v-model="form.bm_id"
                    placeholder="Masukkan ID BM Disini"
                    class="w-full"
                    required
                  />
                  <span
                    v-if="errors.length > 0"
                    class="text-danger text-sm"
                  >{{ errors[0] }}</span>
                </div>
              </ValidationProvider>

              <!-- Business Manager -->
              <ValidationProvider
                v-slot="{ errors }"
                name="Business Manager"
                rules="required"
              >
                <div class="mb-[16px] text-left">
                  <label class="text-[#333333] text-[14px] font-medium mb-[8px] block">
                    Pilih Business Manager
                    <span class="text-primary">*</span>
                  </label>
                  <BFormSelect
                    v-model="form.system_bm_id"
                    :options="metaBusinessManagerOptions"
                  />
                  <span
                    v-if="errors.length > 0 || validationError.system_bm_id"
                    class="text-danger text-sm"
                  >{{ errors[0] || validationError.system_bm_id }}</span>
                </div>
              </ValidationProvider>

              <!-- Ad Account ID -->
              <ValidationProvider
                v-if="form.ad_account_type === defaultAccountTypeKey"
                v-slot="{ errors }"
                rules="required|numeric"
                name="ID Ad Account"
              >
                <div class="mb-[16px] text-left">
                  <label
                    class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                  >
                    Masukkan ID Ad Account <span class="text-primary">*</span>
                  </label>
                  <BFormInput
                    v-model="form.ad_account_id"
                    placeholder="Masukkan ID Ad Account Disini"
                    class="w-full"
                    required
                  />
                  <span
                    v-if="errors.length > 0 || validationError.ad_account_id"
                    class="text-danger text-sm"
                  >
                    {{ errors[0] || validationError.ad_account_id }}
                  </span>
                </div>
              </ValidationProvider>
            </div>
            <!-- Gmail -->
            <div
              v-if="platform === 'google'"
              class="mb-2"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|email"
                name="Gmail"
              >
                <label
                  class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                >
                  Gmail <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.gmail"
                  placeholder="Masukkan gmail Disini"
                  class="w-full"
                  required
                />
                <span
                  v-if="errors.length > 0"
                  class="text-danger text-sm"
                >{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <!-- BC ID -->
            <div
              v-if="platform === 'tiktok'"
              class="mb-2"
            >
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="BC ID TikTok"
              >
                <label
                  class="text-[#333333] text-[14px] font-medium mb-[8px] block"
                >
                  BC ID TikTok <span class="text-primary">*</span>
                </label>
                <BFormInput
                  v-model="form.bc_id"
                  placeholder="Masukkan BC ID Disini"
                  class="w-full"
                  required
                />
                <span
                  v-if="errors.length > 0"
                  class="text-danger text-sm"
                >{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="flex flex-row gap-6">
              <BButton
                variant="outline-primary"
                class="rounded grow"
                @click="$bvModal.hide('modal-add-account')"
              >
                Batal
              </BButton>
              <BButton
                :variant="!invalid && isFormValid ? 'primary' : 'secondary'"
                class="rounded grow"
                :disabled="invalid || !isFormValid"
                @click="showConfirmationModal"
              >
                Tambah Akun
              </BButton>
            </div>
          </BForm>
        </div>
      </ValidationObserver>
    </BModal>

    <!-- Modal Konfirmasi Tambah Akun -->
    <BModal
      id="modal-confirm-add-account"
      hide-footer
      hide-header
      :centered="true"
      content-class="rounded-lg"
    >
      <div class="text-center p-1">
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="Konfirmasi"
          class="mx-auto mb-2"
          width="80px"
        >
        <h1 class="font-semibold text-[18px] text-[#333333] mb-2">
          Konfirmasi Tambah Akun Whitelisted
        </h1>
        <div class="mb-2">
          <p>Penambahan akun ini akan langsung diterapkan partner</p>
        </div>
        <div class="flex flex-row gap-6">
          <BButton
            variant="outline-secondary"
            class="rounded grow"
            @click="$bvModal.hide('modal-confirm-add-account')"
          >
            Batal
          </BButton>

          <BButton
            variant="primary"
            class="rounded grow"
            @click="addAccount"
          >
            Ya, Tambahkan
          </BButton>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { newAxiosIns } from '@/libs/axios'

export default {
  name: 'ModalAddAccount',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    /**
     * Backend validation errors from parent component
     */
    validationError: {
      type: Object,
      default: () => ({
        account_name: '',
        system_bm_id: '',
        ad_account_id: '',
      }),
    },
    platform: {
      type: String,
      required: true,
      validator: value => ['meta', 'google', 'tiktok'].includes(value),
    },
  },
  data() {
    return {
      form: {
        account_name: '',
        bm_id: '',
        gmail: '',
        bc_id: '',
        ad_account_type: '',
        system_bm_id: '',
        marketplace: '',
        marketplace_sync_email: '',
        ad_account_id: '',
      },
      required,
      email,
      adAccountTypes: [
        {
          key: 'whitelist',
          text: 'Meta Whitelisted',
        },
        {
          key: 'cpas',
          text: 'Akun CPAS',
        },
      ],
      metaBusinessManagerOptions: [],
      marketplaceOptions: [],
    }
  },
  computed: {
    /**
     * Check if form is valid for submission based on platform requirements
     * @returns {boolean} True if form is valid
     */
    isFormValid() {
      const hasAccountName = !!this.form.account_name.trim()

      const platformConfig = {
        meta: hasAccountName && !!this.form.bm_id.trim() && !!this.form.system_bm_id.trim(),
        google: hasAccountName && !!this.form.gmail.trim(),
        tiktok: hasAccountName && !!this.form.bc_id.trim(),
      }

      return platformConfig[this.platform]
    },
    /**
     * Default account type key
     * @returns {string}
     */
    defaultAccountTypeKey() {
      return this.adAccountTypes[0].key
    },
  },
  methods: {
    /**
     * Handler executed when ad account button clicked
     * assign value to form payload
    */
    onSelectAdType(adType) {
      this.form.ad_account_type = adType
      this.$emit('select-ad-type')
    },
    /**
     * Handler executed when the component or modal is shown.
     *
     * - Only runs when the selected platform is `meta`
     *
     * @returns {void}
     */
    onShown() {
      if (this.platform !== 'meta') return
      this.form.ad_account_type = this.defaultAccountTypeKey
      this.loadSystemBusinessManagerList()
      this.marketplaceOptions = [
        { value: '', text: 'Pilih Marketplace' },
        { value: 'shopee', text: 'Shopee' },
        { value: 'tokopedia', text: 'Tokopedia' },
      ]
    },
    /**
     * Fetches the system Meta Business Manager list from the API.
     *
     * - Calls the system BM endpoint
     * - Maps API response into `metaBusinessManagerOptions`
     *   for select/dropdown usage
     * - Shows an error toast if the request fails
     *
     * @async
     * @returns {Promise<void>}
     */
    async loadSystemBusinessManagerList() {
      try {
        const {
          data: { data },
        } = await newAxiosIns.get('komads/api/v1/admin/system_bm/list')

        this.metaBusinessManagerOptions = [
          { value: '', text: 'Pilih Business Manager' },
          ...data.map(system => ({
            value: `${system.id}`,
            text: `${system.bm_name} - ${system.bm_id}`,
          })),
        ]
      } catch {
        this.$toast_error({
          message: 'Failed to load business manager list',
        })
      }
    },
    /**
     * Show confirmation modal for adding account
     */
    showConfirmationModal() {
      this.$bvModal.hide('modal-add-account')
      this.$bvModal.show('modal-confirm-add-account')
    },

    resetForm() {
      this.form.account_name = ''
      this.form.bm_id = ''
      this.form.ad_account_type = this.adAccountTypes[0].key
      this.form.system_bm_id = ''
      this.form.gmail = ''
      this.form.marketplace = ''
      this.form.marketplace_sync_email = ''
      this.form.ad_account_id = ''
    },

    /**
     * Add new whitelisted account
     */
    addAccount() {
      // Emit event to parent component with account name
      this.$emit('add-account', this.form)
      // Close confirmation modal
      this.$bvModal.hide('modal-confirm-add-account')

      this.resetForm()
    },
  },
}
</script>
